import { createContext, useContext, useState, type ReactNode } from 'react'

interface HeaderTitleCtx {
  title: string | null
  setTitle: (t: string | null) => void
}

const Ctx = createContext<HeaderTitleCtx>({ title: null, setTitle: () => {} })

export const HeaderTitleProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitle] = useState<string | null>(null)
  return <Ctx.Provider value={{ title, setTitle }}>{children}</Ctx.Provider>
}

export const useHeaderTitle = () => useContext(Ctx)